export type MissionId =
  | "reality"
  | "observer"
  | "laws"
  | "quantum"
  | "computational"
  | "argument"
  | "evidence"
  | "build"
  | "consciousness"
  | "verdict";

export interface MissionDef {
  id: MissionId;
  number: number;
  title: string;
  tagline: string;
  file: string;
}

export const MISSIONS: readonly MissionDef[] = [
  {
    id: "reality",
    number: 1,
    title: "The Reality Test",
    tagline: "Test what your senses can and cannot tell you",
    file: "RealityTest.tsx",
  },
  {
    id: "observer",
    number: 2,
    title: "The Observer",
    tagline: "Measure a hidden object and a double-slit model",
    file: "Observer.tsx",
  },
  {
    id: "laws",
    number: 3,
    title: "The Laws of the Universe",
    tagline: "Change the laws of a toy universe",
    file: "Laws.tsx",
  },
  {
    id: "quantum",
    number: 4,
    title: "The Quantum Question",
    tagline: "Run quantum experiments in a simplified model",
    file: "QuantumQuestion.tsx",
  },
  {
    id: "computational",
    number: 5,
    title: "The Computational Universe",
    tagline: "Grow complexity from simple rules",
    file: "ComputationalUniverse.tsx",
  },
  {
    id: "argument",
    number: 6,
    title: "The Simulation Argument",
    tagline: "Explore Bostrom's argument and its assumptions",
    file: "SimulationArgument.tsx",
  },
  {
    id: "evidence",
    number: 7,
    title: "Search for Evidence",
    tagline: "Weigh the candidate evidence",
    file: "SearchForEvidence.tsx",
  },
  {
    id: "build",
    number: 8,
    title: "Build a Universe",
    tagline: "Design and run your own rule-based world",
    file: "BuildUniverse.tsx",
  },
  {
    id: "consciousness",
    number: 9,
    title: "The Consciousness Problem",
    tagline: "Reflect on experience and computation",
    file: "ConsciousnessProblem.tsx",
  },
  {
    id: "verdict",
    number: 10,
    title: "The Final Verdict",
    tagline: "State what you now think",
    file: "FinalVerdict.tsx",
  },
] as const;
